import { QueryStatus } from 'src/types'
import {OperacionCapitalMarkets} from '../types/types'
import { useEffect, useState } from 'react'
import {HttpCapitalMarkets} from "../api/httpCapitalMarkets";
import {OperacionCapitalMarketsViewDTO} from "../types/dto";

export const useOperacionCapitalMarkets = (idOperacion: number) => {
  const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
  const [operacion, setOperacion] = useState<OperacionCapitalMarketsViewDTO>()

  useEffect(() => {
    setStatus(QueryStatus.Loading)

    HttpCapitalMarkets.get(idOperacion)
      .then(data => {
        setOperacion(data)
        setStatus(QueryStatus.Success)
      })
      .catch(() => setStatus(QueryStatus.Error))
  }, [idOperacion])

  return { status, operacion }
}
